/**
 * De route van een kar door de werkplaats, zoals in het 3D-model van het
 * aanmeldscherm. Los van `Werkplaats3D`, zodat het scherm de route kan tonen zonder
 * three.js mee te laden.
 */
import { AFDELINGSKLEUR } from '@houtstaat/engine';

/** De stations in de volgorde van de route, zoals in het model. */
export const ROUTE = [
  'Plaatmateriaal',
  'Zagerij',
  'Fineerderij',
  'Pers',
  'Schuurmachine',
  'Winkel',
  'Controle',
  'Gereed',
] as const;
export type Station = (typeof ROUTE)[number];

/** De kleur van een station: die van de afdeling, en hout voor het plaatmateriaal. */
export const stationskleur = (s: Station): string =>
  s === 'Plaatmateriaal' ? '#dcbf92' : AFDELINGSKLEUR[s];

export interface Stand {
  /** Waar de kar staat, of waar hij heen rijdt. */
  station: Station;
  rijdt: boolean;
}
